import React, { FC } from 'react';
import cx from 'classnames';

import styles from './TestimonialModule.module.scss';
import { TestimonialAssembly, TestimonialType } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';
import { AppType } from 'services/cms/typesUtil';
import { TestimonialWithImages } from './TestimonialWithImages/TestimonialWithImages';
import { TestimonialOnlyText } from './TestimonialOnlyText/TestimonialOnlyText';
import { TestimonialShowcase } from './TestimonialShowcase/TestimonialShowcase';
import { SubjectImage } from 'components/SubjectImage/SubjectImage';

type TestimonialModuleProps = AppType.Component<FlatEntry<TestimonialAssembly>>;

export const TestimonialModule: FC<TestimonialModuleProps> = ({
  _attributes,
  color,
  backgroundColor,
  secondaryFontColor,
  testimony,
  merchant,
  items,
  mediaTopic,
  stats,
  testimonialType = TestimonialType.WITH_IMAGE,
}) => {
  return (
    <section
      className={cx(styles.moduleWrapper, testimonialType === TestimonialType.SHOWCASE && styles.isShowcase)}
      {..._attributes}
      style={
        {
          '--testimonial-text-color': color,
          '--testimonial-secondary-text-color': secondaryFontColor,
          '--testimonial-background-color': backgroundColor,
        } as React.CSSProperties
      }
    >
      {mediaTopic && (
        <SubjectImage
          entry={mediaTopic}
          className={styles.backgroundImage}
          pictureProps={{ className: styles.imageContainer }}
        />
      )}

      {testimonialType === TestimonialType.NO_IMAGE && (
        <TestimonialOnlyText testimony={testimony} merchant={merchant} />
      )}
      {testimonialType === TestimonialType.WITH_IMAGE && (
        <TestimonialWithImages testimony={testimony} merchant={merchant} items={items} />
      )}
      {testimonialType === TestimonialType.SHOWCASE && (
        <TestimonialShowcase
          testimony={testimony}
          merchant={merchant}
          mediaTopic={mediaTopic}
          hasBackgroundImage={Boolean(mediaTopic)}
          stats={stats}
        />
      )}
    </section>
  );
};

export default TestimonialModule;
